import React from "react";
import TablePagination from "@material-ui/core/TablePagination";
import CaseFilterBar from "./CaseFilterBar";
import CaseTable from "./CaseTable";

/*
Block 7 - composition only. All list state lives in useCaseList.

`cardFilter` ({ label }) is the dashboard card currently narrowing the list
(RMAS-129). While it's applied no chip is active - the card's filters replace
the chip's - and picking a chip, or clearing, drops the card filter.
*/
const CaseListSection = function (props) {
  const { list, onOpen, cardFilter, onClearCardFilter } = props;

  const handleChip = function (chip) {
    if (cardFilter && onClearCardFilter) onClearCardFilter();
    list.setChip(chip);
  };
  const handleClearFilters = function () {
    if (cardFilter && onClearCardFilter) onClearCardFilter();
    list.clearFilters();
  };

  const count = list.loading ? null : list.totalRows;

  return (
    <div className="tn-card tn-caselist">
      {cardFilter ? (
        <div className="tn-cardfilter" role="status">
          <span className="tn-cardfilter-text">
            Filtered by <strong>{cardFilter.label}</strong>
            {count === null ? null : (
              <span className="tn-cardfilter-count">
                {" · " + count + (count === 1 ? " case" : " cases")}
              </span>
            )}
          </span>
          <button
            type="button"
            className="tn-cardfilter-clear"
            onClick={handleClearFilters}
          >
            Clear filter
            <span aria-hidden="true"> ✕</span>
          </button>
        </div>
      ) : null}

      <CaseFilterBar
        searchInput={list.searchInput}
        onSearch={list.setSearchInput}
        chip={cardFilter ? null : list.query.chip}
        onChip={handleChip}
      />

      <CaseTable
        rows={list.rows}
        loading={list.loading}
        hasLoadedOnce={list.hasLoadedOnce}
        error={list.error}
        ordering={list.query.ordering}
        onSort={list.setOrdering}
        onOpen={onOpen}
        onRetry={list.reload}
        onClearFilters={handleClearFilters}
      />

      {/* MUI TablePagination is 0-indexed; the API's `page` is 1-indexed. */}
      <TablePagination
        className="tn-pagination"
        component="div"
        rowsPerPageOptions={[10, 25, 50, 100]}
        count={list.totalRows}
        rowsPerPage={list.query.pageSize}
        page={Math.max(0, list.query.page - 1)}
        onPageChange={function (event, page) {
          list.setPage(page + 1);
        }}
        onRowsPerPageChange={function (event) {
          list.setPageSize(parseInt(event.target.value, 10));
        }}
      />
    </div>
  );
};

export default CaseListSection;
